import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

// ← rename employeeId to smeid to match API query param
export interface GetSMEDetailsApiParameter extends ApiParameter {
    smeid: string;
}

export interface SMEDetailModel {
    id: string;
    name: string;
    title: string;
    bioSnippet: string;
    bioFull: string;
    photoUrl: string | null;
    branchName: string;
    email: string;
    phone: string;
    startDate: string;
    education: string;
    trainingsAttended: string;
    personalInterests: string;
    isSme: boolean;
    isDsm: boolean;
    isTextMessageAllowed?: boolean;
    productTypesExpertise?: {
  name: string;
  isTechnicalSupport: boolean;
  isPriceAndAvailability: boolean;
}[];

brandsExpertise?: {
  name: string;
  isTechnicalSupport: boolean;
  isPriceAndAvailability: boolean;
}[];
  
    isTechnicalSupport?: boolean;
    isPriceAndAvailability?: boolean;
}

export interface SMEDetailsResponseModel {
    smeDetail: SMEDetailModel;
    relatedSmeDetailslist: SMEDetailModel[];
    properties: Record<string, unknown>;
}

const baseUrl = "/api/v2/centroconnect/sme/smedetails";

export function getSMEDetails(parameter: GetSMEDetailsApiParameter) {
    return get<SMEDetailsResponseModel>(baseUrl, parameter);
}
